import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ChevronRight, DollarSign, Bitcoin, Briefcase, LineChart, PieChart } from 'lucide-react'
import AnimatedBackground from '../../utils/AnimatedBackground'
import { Card, CardHeader, CardTitle, CardContent } from "../../ui/card"
import TopBar from '../../utils/TopBar';
import Footer from '../../utils/Footer';

const ImportInvestments: React.FC = () => {
  const navigate = useNavigate()

  const handleAssetTypeSelection = (assetType: string) => {
    navigate(`/investments/import/${assetType}`)
  }

  const assetTypes = [
    { type: 'stock', icon: DollarSign, label: 'Stock' },
    { type: 'digital-coin', icon: Bitcoin, label: 'Digital Coin' },
    { type: 'tesouro-direto', icon: Briefcase, label: 'Tesouro Direto' },
    { type: 'fixed-investment', icon: LineChart, label: 'Fixed Investment' },
    { type: 'investment-funds', icon: PieChart, label: 'Investment Funds' },
  ]

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col relative">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <TopBar 
          title="Import Investments"
          subtitle="Import your investments data"
        />
        <main className="relative z-10 p-4 sm:p-6 lg:p-8 flex items-center justify-center flex-1">
          <div className="w-full max-w-3xl">
            <Card className="bg-[#0f1115] border-gray-800">
              <CardHeader>
                <CardTitle className="text-white text-center">Select Asset Type</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 gap-6">
                  {assetTypes.map(({ type, icon: Icon, label }) => (
                    <motion.button
                      key={type}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => handleAssetTypeSelection(type)}
                      className="relative flex items-center justify-between px-8 py-6 rounded-xl transition-all bg-black text-white shadow-lg hover:shadow-xl group overflow-hidden w-full"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-indigo-500/20 opacity-0 group-hover:opacity-100 group-active:opacity-100 transition-opacity"></div>
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-indigo-500/20 animate-gradient-x"></div>
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-400/10 to-transparent animate-pulse"></div>
                      <div className="relative flex items-center z-10">
                        <Icon className="w-8 h-8 mr-4" />
                        <span className="text-xl font-semibold">{label}</span>
                      </div>
                      <ChevronRight className="relative w-6 h-6 transform group-hover:translate-x-2 transition-transform z-10" />
                    </motion.button>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </main>
        <Footer />
      </div>

      <style>{`
        @keyframes gradient-x {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient-x {
          animation: gradient-x 3s ease infinite;
          background-size: 400% 400%;
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.1; }
          50% { opacity: 0.4; }
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </div>
  )
}

export default ImportInvestments